import { useMemo } from 'react'
import { useParams, Link, Navigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { HiCalendar, HiArrowLeft } from 'react-icons/hi'
import { useLocalizedLink } from '../../hooks/useLocalizedLink'
import { getNewsById } from '../../data/newsData'
import SEO from '../../components/SEO/SEO'
import './NewsDetail.css'

function NewsDetail() {
  const { t, i18n } = useTranslation()
  const { newsId } = useParams()
  const getLocalizedLink = useLocalizedLink()
  
  const news = getNewsById(newsId, i18n.language)

  const breadcrumbItems = useMemo(() => {
    if (!news) return undefined
    return [
      { name: t('common.home'), pathSuffix: '' },
      { name: t('common.news'), pathSuffix: 'news' },
      { name: news.title, pathSuffix: `news/${news.id}` },
    ]
  }, [news, t])

  if (!news) {
    return <Navigate to={getLocalizedLink('/news')} replace />
  }

  return (
    <div className="news-detail-page">
      <SEO 
        title={news.title}
        description={news.excerpt.substring(0, 160)}
        breadcrumbItems={breadcrumbItems}
      />
      <div className="container">
        <Link to={getLocalizedLink('/news')} className="news-detail-back">
          <HiArrowLeft className="back-icon" />
          <span>{t('news.backToNews', 'Back to News')}</span>
        </Link>

        <article className="news-detail-article">
          {news.image && (
            <div className="news-detail-image-wrapper">
              <img 
                src={news.image} 
                alt={news.title}
                className="news-detail-image"
                style={{ objectFit: news.imageFit || 'cover' }}
              />
            </div>
          )}
          
          <div className="news-detail-header">
            <div className="news-detail-date">
              <HiCalendar className="date-icon" />
              <span>{news.date}</span>
            </div>
            <h1 className="news-detail-title">{news.title}</h1>
          </div>

          <div className="news-detail-content">
            <p className="news-detail-text">{news.excerpt}</p>
            {news.articleImages?.length > 0 && (
              <div className="news-detail-inline-images">
                {news.articleImages.map((img) => (
                  <figure key={img.src} className="news-detail-inline-image-wrapper">
                    <img src={img.src} alt={img.alt} className="news-detail-inline-image" loading="lazy" />
                  </figure>
                ))}
              </div>
            )}
          </div>
        </article>
      </div>
    </div>
  )
}

export default NewsDetail

